import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ESmartCoolerTransactionType,
  ICoolerSingleTransactionResponse,
  ICoolerTransaction,
  ICoolerTransactionResponse,
  IFetchCoolerTransactions,
  IFetchSingleCoolerTransaction,
} from '@/pages/CoolerTransaction/coolerTransaction.interface';

export interface CoolerTransactionState {
  coolerTransactions: ICoolerTransactionResponse;
  listLoading: boolean;
  singleLoading: boolean;
  error: boolean;
  coolerTransaction: ICoolerSingleTransactionResponse;
}

export const initialState: CoolerTransactionState = {
  coolerTransactions: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalItems: 0,
      totalPages: 0,
      nextPage: null,
      previousPage: null,
    },
    success: false,
    message: '',
  },
  coolerTransaction: {
    data: null,
    success: false,
    message: '',
  },
  listLoading: false,
  singleLoading: false,
  error: false,
};

const coolerTransactionSlice = createSlice({
  name: 'coolerTransaction',
  initialState,
  reducers: {
    getCoolerTransactions: (
      state,
      _action: PayloadAction<IFetchCoolerTransactions>,
    ) => {
      state.listLoading = true;
      state.error = false;
    },
    getCoolerTransactionsSuccess: (
      state,
      action: PayloadAction<ICoolerTransactionResponse>,
    ) => {
      state.listLoading = false;
      state.coolerTransactions = { ...action.payload };
    },
    getCoolerTransactionsFailure: (state, action: any) => {
      state.listLoading = false;
      state.error = true;
      state.coolerTransactions = {
        success: false,
        data: [],
        pagination: {
          totalRecords: 0,
          currentPage: 0,
          totalItems: 0,
          totalPages: 0,
          nextPage: null,
          previousPage: null,
        },
        message: action.payload?.messageDetails?.length ?  action.payload?.messageDetails[0]?.message : action.payload?.message
      }
    },
    getCoolerTransaction: (
      state,
      _action: PayloadAction<IFetchSingleCoolerTransaction>,
    ) => {
      state.singleLoading = true;
    },
    getCoolerTransactionSuccess: (
      state,
      action: PayloadAction<ICoolerSingleTransactionResponse>,
    ) => {
      state.singleLoading = false;
      state.coolerTransaction = { ...action.payload };
    },
    getCoolerTransactionFailure: (state, action:any) => {
      state.singleLoading = false;
      state.error = true;
      state.coolerTransaction = {
        success: false,
        data: null,
        message: action.payload?.messageDetails?.length ?  action.payload?.messageDetails[0]?.message : action.payload?.message
      };
    },
    resetCoolerTransactions: (state) => {
      state.coolerTransactions = initialState.coolerTransactions;
      state.listLoading = false;
      state.error = false;
    },
    resetCoolerTransaction: (state) => {
      state.coolerTransaction = initialState.coolerTransaction;
      state.singleLoading = false;
      state.error = false;
    },
    clearCoolerTransactionsError: (state) => {
      state.error = false;
    },
  },
});

export const {
  getCoolerTransactions,
  getCoolerTransactionsSuccess,
  getCoolerTransactionsFailure,
  getCoolerTransaction,
  getCoolerTransactionSuccess,
  getCoolerTransactionFailure,
  resetCoolerTransactions,
  resetCoolerTransaction,
  clearCoolerTransactionsError
} = coolerTransactionSlice.actions;

export default coolerTransactionSlice.reducer;
